export class TrafficNewsBadge {
    constructor(badgeSelector = '.traffic-news-badge__wrapper', reloadButtonSelector = '.traffic-news-badge__reloadbutton', closeButtonSelector = '.traffic-news-badge__close', idleTimeMs = 5 * 60 * 1000) {
        this.timerId = null;
        this.badge = document.querySelector(badgeSelector);
        this.reloadButton = document.querySelector(reloadButtonSelector);
        this.closeButton = document.querySelector(closeButtonSelector);
        this.idleTimeMs = idleTimeMs;
        if (this.badge && this.reloadButton && this.closeButton) {
            this.init();
        }
    }
    init() {
        this.timerId = window.setTimeout(() => this.showBadge(), this.idleTimeMs);
        this.reloadButton.addEventListener('click', () => {
            this.hideBadge();
            window.location.reload();
        });
        this.closeButton.addEventListener('click', () => {
            this.hideBadge();
        });
    }
    showBadge() {
        if (this.badge) {
            this.badge.style.display = 'block';
            setTimeout(() => this.badge.classList.add('show'), 10);
        }
    }
    hideBadge() {
        if (this.badge) {
            this.badge.classList.remove('show');
            this.badge.classList.add('hide');
            setTimeout(() => {
                if (this.badge) {
                    this.badge.style.display = 'none';
                    this.badge.classList.remove('hide');
                }
            }, 500);
        }
        if (this.timerId !== null) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
    }
}
export function initTrafficNewsBadge() {
    new TrafficNewsBadge();
}
